// Presentation copy from the approved TikCare_pricing_redesign.html.
// Display only: billing prices and credit charges remain server-authoritative.
export const PRICING_PLANS = [
  {
    "name": "Free",
    "audience": "Explore how AI brings more clients and save time for your first month.",
    "details": [
      "Use the credits however you like, generate case notes, transcribe or prescribe AI Home Practice Assistant and more",
      "Unused trial credits expire when the month ends",
      "Your account remains active after free plan expires",
      "Upgrade to a paid plan anytime"
    ]
  },
  {
    "name": "Basic",
    "audience": "For part-timer practitioners",
    "details": [
      "Credits reset monthly, unused trial credits expire when the month ends",
      "Cancel anytime",
      "Your account remains active after the plan expires",
      "Change to another paid plan anytime"
    ]
  },
  {
    "name": "Pro",
    "audience": "For higher-volume practices.",
    "details": [
      "10% cheaper monthly credits than Basic plan",
      "Credits reset monthly, unused trial credits expire when the month ends",
      "Cancel anytime",
      "Your account remains active after the plan expires",
      "Change to another paid plan anytime"
    ]
  }
];
export const PRICING_USAGE = [
  {
    "title": "Live transcription",
    "description": "Real-time transcription turns speech into text as a session happens.",
    "cost": "3 credits / hour"
  },
  {
    "title": "Recorded transcription",
    "description": "Turns an uploaded session recording into text afterward.",
    "cost": "1 credit / hour"
  },
  {
    "title": "Generated documents",
    "description": "Generate customised case notes, reports, session summaries, home practice and more.",
    "cost": "1 credit / document"
  },
  {
    "title": "OCR",
    "description": "Digitise text accurately from multi-lingual handwriting, forms, checkboxes, symbols and more.",
    "cost": "1 credit / uploaded document"
  },
  {
    "title": "AI Home Practice Assistant",
    "description": "Follow up on home practice prescribed for your clients between sessions, with their progress visible to you. Clients booked via the MindVault platform enjoy it for free. Self-brought clients require credits.",
    "cost": "10 credits / client / month"
  },
  {
    "title": "Ask Sophie",
    "description": "An intelligent AI assistant that remembers every client’s case history. It helps draft content, suggest home practice ideas, research topics and more.",
    "cost": "Free"
  }
];
